import _ from 'lodash';
import { MutationTree } from 'vuex';
import { FiltersEvents, FiltersEventsState } from '@/models/states/filters-state.model';

export const mutations: MutationTree<FiltersEventsState> = {
  onUpdateFilters(state, payload: FiltersEvents) {
    state.filters = _.extend({}, state.filters, payload);
  },
};
